@if (!href) {
  <div class="button" [ngClass]="[(working ? 'working' : stateClass), (selected ? 'selected' : '')]" [attr.badge]="badgeText" [attr.info]="hasAddBadge ? '' : null" [attr.fa]="hasAddBadge ? '' : null">
    <ng-container *ngTemplateOutlet="buttonContents" />
  </div>
}
@if (href) {
  <a class="button" [ngClass]="[(working ? 'working' : stateClass), (selected ? 'selected' : '')]" [attr.badge]="badgeText" [attr.info]="hasAddBadge ? '' : null" [attr.fa]="hasAddBadge ? '' : null" [attr.href]="href" [attr.target]="isLocalLink ? undefined : '_blank'">
    <ng-container *ngTemplateOutlet="buttonContents" />
  </a>
}
<ng-template #buttonContents>
  <ng-content select="icon" />
  @if (showSaved() || (working && progression) || label != '') {
    <span>{{ showSaved() ? labelSaved : working && progression ? ('submit-button.progression' | translate: progression) : label }}</span>
  }
  <span><ng-content /></span>
</ng-template>
